<body
  bgcolor="#d7d7d7"
  class="generic-template"
  style="
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    background-color: #d7d7d7;
    margin: 0;
    padding: 0;
  "
>
  <!-- Header Start -->
  <div
    class="bg-white header"
    bgcolor="#ffffff"
    style="background-color: white; width: 100%"
  >
    <table
      align="center"
      bgcolor="#ffffff"
      style="
        border-left: 10px solid white;
        border-right: 10px solid white;
        max-width: 600px;
        width: 100%;
      "
    >
      <tr height="80"></tr>
    </table>
  </div>
  <!-- Header End -->

  <!-- Content Start -->
  <table
    cellpadding="0"
    cellspacing="0"
    cols="1"
    bgcolor="#d7d7d7"
    align="center"
    style="max-width: 600px"
  >
    <tr bgcolor="#d7d7d7">
      <td
        height="50"
        style="
          color: #464646;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
          font-size: 14px;
          line-height: 16px;
          vertical-align: top;
        "
      ></td>
    </tr>

    <!-- This encapsulation is required to ensure correct rendering on Windows 10 Mail app. -->
    <tr bgcolor="#d7d7d7">
      <td
        style="
          color: #464646;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
          font-size: 14px;
          line-height: 16px;
          vertical-align: top;
        "
      >
        <!-- Seperator Start -->
        <table
          cellpadding="0"
          cellspacing="0"
          cols="1"
          bgcolor="#d7d7d7"
          align="center"
          style="max-width: 600px; width: 100%"
        >
          <tr bgcolor="#d7d7d7">
            <td
              height="30"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>
        </table>
        <!-- Seperator End -->

        <!-- Generic Pod Left Aligned with Price breakdown Start -->
        <table
          align="center"
          cellpadding="0"
          cellspacing="0"
          cols="3"
          bgcolor="white"
          class="bordered-left-right"
          style="
            border-left: 10px solid #d7d7d7;
            border-right: 10px solid #d7d7d7;
            max-width: 600px;
            width: 100%;
          "
        >
          <tr height="50">
            <td
              colspan="3"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>
          <tr align="center">
            <td
              width="36"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
            <td
              class="text-primary"
              style="
                color: #f16522;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            >
              <img
                src="http://dgtlmrktng.s3.amazonaws.com/go/emails/generic-email-template/tick.png"
                alt="GO"
                width="50"
                style="
                  border: 0;
                  font-size: 0;
                  margin: 0;
                  max-width: 100%;
                  padding: 0;
                "
              />
            </td>
            <td
              width="36"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>
          <tr height="17">
            <td
              colspan="3"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>
          <tr align="center">
            <td
              width="36"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
            <td
              class="text-primary"
              style="
                color: #f16522;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            >
              <h1
                style="
                  color: #f16522;
                  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                  font-size: 30px;
                  font-weight: 700;
                  line-height: 34px;
                  margin-bottom: 0;
                  margin-top: 0;
                "
              >
                Payment Successful
              </h1>
            </td>
            <td
              width="36"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>
          <tr height="30">
            <td
              colspan="3"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>

          <tr height="30">
            <td
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
            <td
              style="
                border-bottom: 1px solid #d3d1d1;
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
            <td
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>
          <tr height="30">
            <td
              colspan="3"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>

          <tr height="50" class="text-center">
            <td
              colspan="3"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            >
              <a href="javascript:" (click)="homePage()">Proceed</a>
            </td>
          </tr>
        </table>
        <!-- Generic Pod Left Aligned with Price breakdown End -->

        <!-- Seperator Start -->
        <table
          cellpadding="0"
          cellspacing="0"
          cols="1"
          bgcolor="#d7d7d7"
          align="center"
          style="max-width: 600px; width: 100%"
        >
          <tr bgcolor="#d7d7d7">
            <td
              height="50"
              style="
                color: #464646;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                vertical-align: top;
              "
            ></td>
          </tr>
        </table>
        <!-- Seperator End -->
      </td>
    </tr>
  </table>
  <!-- Content End -->
</body>
